import React, { useContext } from "react";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import styled from "styled-components";
import { ColumnListItem } from "./ColumnListItem";
import { ColumnOptionsContext } from "./ColumnOptions";

export const ColumnList = () => {
  const { columns, onReorderColumn } = useContext(ColumnOptionsContext);

  const visibleColumns = columns.filter(
    (col) => col.isPresentInColumnOptions !== false
  );

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;

    // Find actual indices in the full columns array
    const sourceCol = visibleColumns[result.source.index];
    const destCol = visibleColumns[result.destination.index];

    // Don't allow dropping onto or before fixed columns
    if (destCol.isFixed) return;

    const sourceIndex = columns.findIndex((c) => c.key === sourceCol.key);
    const destIndex = columns.findIndex((c) => c.key === destCol.key);

    if (sourceIndex !== -1 && destIndex !== -1) {
      onReorderColumn(sourceIndex, destIndex);
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="column-options-list">
        {(provided) => (
          <ScrollContainer
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {visibleColumns.map((col, index) => (
              <Draggable
                key={col.key}
                draggableId={col.key}
                index={index}
                isDragDisabled={col.isFixed}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{
                      ...provided.draggableProps.style,
                      opacity: snapshot.isDragging ? 0.8 : 1,
                    }}
                  >
                    <ColumnListItem
                      column={col}
                      isDragging={snapshot.isDragging}
                      dragHandleProps={provided.dragHandleProps}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ScrollContainer>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const ScrollContainer = styled.div`
  flex: 1;
  padding: 8px 16px;
  overflow-y: auto;
  overflow-x: hidden;
`;
